import { Character } from '../components/ui';
import type { ReactionGuide, ReactionPose } from './reactionCatalog';

const HANEUL: Record<string, string> = {
  guide:'wave', think:'think', record:'report', run:'run', surprise:'surprise', heart:'heart', celebrate:'celebrate', research:'star', checklist:'thumbs',
};
const SAGE: Record<string, string> = {
  guide:'checklist', think:'binocular', record:'calculator', run:'checklist', surprise:'binocular', heart:'checklist', celebrate:'checklist', research:'research', checklist:'checklist',
};
const SNOWS: Record<ReactionPose, string> = {
  guide:'wave',
  think:'notebook',
  record:'notebook',
  run:'run',
  surprise:'run',
  heart:'piggybank',
  celebrate:'thumbs',
  research:'notebook',
  checklist:'notebook',
};

export function guideCharacterAsset(guide: ReactionGuide, pose: ReactionPose): string {
  if (guide === 'snows') return `/assets/characters/snows/snows_${SNOWS[pose]}_v1.png`;
  if (guide === 'sage') return `/assets/characters/sage/sage_${SAGE[pose] ?? 'checklist'}_v1.png`;
  return `/assets/characters/haneul/haneul_${HANEUL[pose] ?? 'wave'}_v1.png`;
}

export function GuideCharacter({ guide, pose = 'guide', alt, state = 'idle', priority = false, className = '' }: {
  guide: ReactionGuide;
  pose?: ReactionPose;
  alt: string;
  state?: 'idle' | 'guide' | 'think' | 'celebrate' | 'quiet';
  priority?: boolean;
  className?: string;
}) {
  return <span className={`guide-character guide-${guide} guide-state-${state} ${className}`}>
    <span className="guide-character-aura" aria-hidden="true" />
    <Character src={guideCharacterAsset(guide, pose)} alt={alt} priority={priority} />
  </span>;
}
